import { Rule } from "antd/es/form";

class Validators {

  readonly isRequired: Rule[] = [{ required: true }];
  readonly isRequiredEmail: Rule[] = [{ type: 'email', required: true }];
  readonly isRequiredPhoneNumber: Rule[] = [
    { required: true },
    {
      pattern: /^(\+?\d{1,2}[\s.-]?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/i,
      message: 'Phone number must be valid',
      validateTrigger: 'onChange',
    },
  ];

  isRequiredBillAccount(isBillAccount: boolean): Rule[] {
    return [
      { required: isBillAccount },
      {
        pattern: /^([A-Z]-\d{4}|\d{2}-\d{4})$/, // X-0000 format
        message: 'Account number must be in the format X-0000 or 00-0000',
        validateTrigger: 'onChange',
      },
    ];
  }

}

export default new Validators();
